type ErrorService = string;

interface LoggerInput {
  service: ErrorService;
  level: 'ERROR' | 'WARN' | 'INFO';
  body: any;
}

/**
 * `message`/`stack`/`cause` are non-enumerable on Error instances, so `JSON.stringify(someError)`
 * silently produces `{}` — this pulls them out explicitly (recursing into `cause`, e.g. Node's
 * fetch-failure TypeError wrapping a system error like ENOTFOUND/ECONNREFUSED) so logs retain
 * the actual failure reason instead of an empty object. Use on any caught error before passing
 * it into a logger `body`.
 */
export const serializeError = (e: unknown): unknown => {
  if (!(e instanceof Error)) {
    return e;
  }
  const { name, message, stack, cause, ...rest } = e as Error & Record<string, unknown>;
  return {
    name,
    message,
    stack,
    ...rest,
    ...(cause !== undefined && { cause: serializeError(cause) }),
  };
};

export const logger = ({ service, level, body }: LoggerInput) => {
  const output = JSON.stringify({ service, level, ...body });

  switch (level) {
    case 'ERROR':
      console.error(output);
      break;
    case 'WARN':
      console.warn(output);
      break;
    default:
      console.log(output);
      break;
  }
};
